/* corex-textil-editor-io.js · Utilidades y carga de archivos del personalizador de camisetas:
   fotos de la prenda (CORS), imágenes PNG/JPG y PDF (pdf.js bajo demanda, página 1 a 300 ppp). Los PNG y los PDF
   se recortan a la caja de los píxeles con alfa > 8 (sin margen y a la resolución original): ese recorte es la imagen
   de la capa, así que su tamaño, la cota, el cobro y el PNG de impresión salen del dibujo real. */
(function () {
  'use strict';

  var MAX_IMG_BYTES = 25 * 1024 * 1024;
  var MAX_PDF_BYTES = 60 * 1024 * 1024;
  var ACCEPTED_TYPES = ['image/png', 'image/jpeg'];
  var PDFJS_BASE = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/6.3.289/';
  var PDF_DPI = 300;
  var PT_TO_CM = 2.54 / 72;
  var MAX_PDF_PIXELS = 40 * 1000 * 1000;
  var THUMB_PX = 64;
  var ALPHA_MIN = 8;
  /* Resolución mínima guardada en un PNG/JPG para tomar su tamaño en cm: 72 y 96 ppp son los valores por defecto de
     pantalla (no dicen nada del tamaño de impresión); desde 100 ppp el archivo se preparó para imprimir. */
  var MIN_PRINT_DPI = 100;
  var HEADER_BYTES = 256 * 1024;
  var MIN_TRIM_PX = 2;
  /* Proxy de packshots TopTex con CORS abierto: permite leer los píxeles de la foto en el canvas. */
  var PACKSHOT_PROXY = 'https://corex-toptex-sync.vercel.app/api/toptex/packshot?url=';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function uid() { return 'l' + Math.random().toString(36).slice(2, 10); }
  function round(v, d) { var f = Math.pow(10, d || 0); return Math.round(v * f) / f; }
  function fmt(v) { return String(round(v, 1)).replace('.', ','); }
  function normalizeDeg(d) { return round(((d + 540) % 360) - 180, 1); }
  /* Número en cm escrito por el cliente (admite coma). { value } | { empty } | { invalid } */
  function parseCm(raw, min, max) {
    var t = String(raw == null ? '' : raw).trim().replace(',', '.');
    if (!t) return { empty: true };
    var n = Number(t);
    return isFinite(n) && n >= min && n <= max ? { value: n } : { invalid: true };
  }
  function userError(msg) { return Object.assign(new Error(msg), { userFacing: true }); }

  /* ---------- carga de imágenes ---------- */
  var photoCache = {};
  function loadPhoto(url) {
    if (!photoCache[url]) {
      photoCache[url] = new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.onload = function () { resolve(img); };
        img.onerror = function () { delete photoCache[url]; reject(new Error('photo')); };
        img.src = url;
      });
    }
    return photoCache[url];
  }
  /* URL del proxy para una foto de corex.packshots, o null si no es una URL https válida. */
  function packshotUrl(url) {
    return typeof url === 'string' && /^https:\/\/[^\s]+$/i.test(url) ? PACKSHOT_PROXY + encodeURIComponent(url) : null;
  }
  /* Foto opcional: resuelve null si no hay URL o no carga (el llamador usa su respaldo). */
  function loadOptionalPhoto(url) {
    return url ? loadPhoto(url).catch(function () { return null; }) : Promise.resolve(null);
  }
  function thumbOf(img) {
    var c = document.createElement('canvas'), s = THUMB_PX / Math.max(img.naturalWidth, img.naturalHeight);
    c.width = Math.max(1, Math.round(img.naturalWidth * s));
    c.height = Math.max(1, Math.round(img.naturalHeight * s));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/png');
  }
  function imageFromSrc(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(userError('La imagen parece dañada y no se puede abrir.')); };
      img.src = src;
    });
  }
  /* Caja de los píxeles con alfa > min en un RGBA de w×h: { x, y, w, h } o null si todo es transparente. */
  function alphaBox(data, w, h, min) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      var row = y * w * 4, hit = false;
      for (var x = 0; x < w; x++) {
        if (data[row + x * 4 + 3] > min) {
          hit = true;
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
        }
      }
      if (hit) { if (y < y0) y0 = y; y1 = y; }
    }
    return x1 < 0 ? null : { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
  }
  /* Recorta el margen transparente de res ({ src, img, physW }); physW (PDF) se reduce en proporción. */
  function trimTransparent(res) {
    var img = res.img, w = img.naturalWidth, h = img.naturalHeight;
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    var box = alphaBox(ctx.getImageData(0, 0, w, h).data, w, h, ALPHA_MIN);
    if (!box) return Promise.reject(userError('La imagen es totalmente transparente: no hay nada que imprimir.'));
    if (box.w < MIN_TRIM_PX || box.h < MIN_TRIM_PX) return Promise.reject(userError('El dibujo de la imagen es demasiado pequeño (menos de 2 px) para imprimirlo.'));
    if (box.w === w && box.h === h) return Promise.resolve(res);
    var out = document.createElement('canvas');
    out.width = box.w;
    out.height = box.h;
    out.getContext('2d').drawImage(c, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
    var src = out.toDataURL('image/png');
    return imageFromSrc(src).then(function (cropped) {
      return { src: src, img: cropped, physW: res.physW == null ? null : res.physW * box.w / w };
    });
  }
  /* Resolución guardada en un PNG (chunk pHYs en metros) o un JPG (EXIF XResolution o JFIF), en ppp; null si no hay. */
  function densityOf(bytes) {
    var d = bytes, u16 = function (p, le) { return le ? d[p] | d[p + 1] << 8 : d[p] << 8 | d[p + 1]; };
    var u32 = function (p, le) { return le ? (d[p] | d[p + 1] << 8 | d[p + 2] << 16 | d[p + 3] << 24) >>> 0 : (d[p] << 24 | d[p + 1] << 16 | d[p + 2] << 8 | d[p + 3]) >>> 0; };
    var str = function (p, n) { return String.fromCharCode.apply(null, Array.prototype.slice.call(d, p, p + n)); };
    if (d.length > 8 && d[0] === 0x89 && str(1, 3) === 'PNG') {
      for (var p = 8; p + 8 <= d.length;) {
        var len = u32(p), type = str(p + 4, 4);
        if (type === 'pHYs' && p + 17 <= d.length) return d[p + 16] === 1 ? u32(p + 8) * 0.0254 : null;
        if (type === 'IDAT' || type === 'IEND') return null;
        p += 12 + len;
      }
      return null;
    }
    if (d.length < 4 || d[0] !== 0xFF || d[1] !== 0xD8) return null;
    var jfif = null;
    for (var q = 2; q + 4 <= d.length && d[q] === 0xFF;) {
      var m = d[q + 1], seg = u16(q + 2), s = q + 4;
      if (m === 0xDA || m === 0xD9) break;
      if (m === 0xE0 && str(s, 5) === 'JFIF\0') {
        var units = d[s + 7], x = u16(s + 8);
        jfif = units === 1 ? x : units === 2 ? x * 2.54 : null;
      }
      if (m === 0xE1 && str(s, 6) === 'Exif\0\0') {
        var t = s + 6, le = str(t, 2) === 'II', ifd = t + u32(t + 4, le), n = u16(ifd, le), xres = null, unit = 2;
        for (var i = 0; i < n; i++) {
          var e = ifd + 2 + i * 12, tag = u16(e, le);
          if (tag === 0x011A) { var o = t + u32(e + 8, le), den = u32(o + 4, le); xres = den ? u32(o, le) / den : null; }
          if (tag === 0x0128) unit = u16(e + 8, le);
        }
        if (xres) return unit === 3 ? xres * 2.54 : unit === 2 ? xres : null;
      }
      q += 2 + seg;
    }
    return jfif;
  }
  /* Ancho en cm según la resolución guardada (solo si es de impresión, ≥ MIN_PRINT_DPI); si no, null. */
  function physWidth(px, dpi) { return dpi && dpi >= MIN_PRINT_DPI ? px / dpi * 2.54 : null; }
  function readImageFile(file) {
    if (ACCEPTED_TYPES.indexOf(file.type) === -1) return Promise.reject(userError('Formato no admitido. Sube PNG, JPG o PDF.'));
    if (file.size > MAX_IMG_BYTES) return Promise.reject(userError('La imagen supera 25 MB. Prueba con una versión más ligera.'));
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function () { reject(userError('No se ha podido leer la imagen. Inténtalo de nuevo.')); };
      reader.onload = function () { resolve(reader.result); };
      reader.readAsDataURL(file);
    }).then(function (src) {
      var head = file.slice(0, HEADER_BYTES).arrayBuffer().then(function (b) { return densityOf(new Uint8Array(b)); }).catch(function () { return null; });
      return Promise.all([imageFromSrc(src), head]).then(function (r) { return { src: src, img: r[0], physW: physWidth(r[0].naturalWidth, r[1]) }; });
    }).then(function (res) { return file.type === 'image/png' ? trimTransparent(res) : res; });
  }
  /* import() de un módulo ES desde un <script type="module">: el minificador de assets de Shopify convierte el
     import() de este archivo en require() y rompe la carga. */
  function importModule(url) {
    return new Promise(function (resolve, reject) {
      var key = '__cteImport' + uid(), el = document.createElement('script');
      var done = function (fn) { return function (v) { delete window[key]; el.remove(); fn(v); }; };
      window[key] = { ok: done(resolve), fail: done(reject) };
      el.type = 'module';
      el.textContent = 'import(' + JSON.stringify(url) + ').then(window.' + key + '.ok, window.' + key + '.fail);';
      document.head.appendChild(el);
    });
  }
  var pdfjsPromise = null;
  function loadPdfJs() {
    if (!pdfjsPromise) {
      pdfjsPromise = importModule(PDFJS_BASE + 'pdf.min.mjs').then(function (lib) {
        lib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + 'pdf.worker.min.mjs';
        return lib;
      }).catch(function () {
        pdfjsPromise = null;
        throw userError('No se ha podido abrir el lector de PDF. Revisa la conexión e inténtalo de nuevo.');
      });
    }
    return pdfjsPromise;
  }
  /* PDF: solo la página 1, a 300 ppp según su tamaño físico; la capa conserva ese tamaño en cm si cabe. */
  function readPdfFile(file) {
    if (file.size > MAX_PDF_BYTES) return Promise.reject(userError('El PDF supera 60 MB. Prueba con una versión más ligera.'));
    return Promise.all([loadPdfJs(), file.arrayBuffer()])
      .then(function (r) { return r[0].getDocument({ data: new Uint8Array(r[1]) }).promise; })
      .then(function (pdf) {
        return pdf.getPage(1).then(function (page) {
          var base = page.getViewport({ scale: 1 });
          var scale = PDF_DPI / 72;
          if (base.width * base.height * scale * scale > MAX_PDF_PIXELS) scale = Math.sqrt(MAX_PDF_PIXELS / (base.width * base.height));
          var vp = page.getViewport({ scale: scale });
          var c = document.createElement('canvas');
          c.width = Math.floor(vp.width);
          c.height = Math.floor(vp.height);
          /* fondo transparente para poder recortar el margen: pdf.js pinta blanco por defecto y, si recibe el canvas
             en vez del contexto, lo abre sin canal alfa */
          return page.render({ canvasContext: c.getContext('2d'), viewport: vp, intent: 'print', background: 'rgba(0,0,0,0)' }).promise.then(function () {
            var src = c.toDataURL('image/png');
            pdf.loadingTask.destroy();
            return imageFromSrc(src).then(function (img) { return trimTransparent({ src: src, img: img, physW: base.width * PT_TO_CM }); });
          });
        }).catch(function (err) { pdf.loadingTask.destroy(); throw err; });
      })
      .catch(function (err) {
        if (err && err.userFacing) throw err;
        throw userError('No se ha podido leer el PDF. Comprueba que no esté protegido o dañado.');
      });
  }
  function isPdf(file) { return file.type === 'application/pdf' || /\.pdf$/i.test(file.name || ''); }

  /* Fondo del círculo de un color: su HEX guardado (corex.color_hex; bicolor, mitad y mitad) o, si no lo tiene, la
     miniatura de la variante. light: color muy claro (blanco, crudo), que necesita borde para distinguirse. */
  var LIGHT_LUMA = 0.86;
  function swatchStyle(c) {
    var h = c && c.hex;
    if (h && /^#[0-9A-F]{6}$/i.test(h.hex)) {
      var two = h.hex2 && /^#[0-9A-F]{6}$/i.test(h.hex2);
      var luma = function (x) { return (0.299 * parseInt(x.slice(1, 3), 16) + 0.587 * parseInt(x.slice(3, 5), 16) + 0.114 * parseInt(x.slice(5, 7), 16)) / 255; };
      return { style: 'background:' + (two ? 'linear-gradient(135deg,' + h.hex + ' 50%,' + h.hex2 + ' 50%)' : h.hex),
        light: luma(h.hex) > LIGHT_LUMA || (two && luma(h.hex2) > LIGHT_LUMA) };
    }
    return { style: c && c.thumb ? 'background-image:url(' + esc(c.thumb) + ')' : '', light: false };
  }

  var ICON_EYE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ICON_EYE_OFF = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 3l18 18M10.6 5.1A10 10 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-3.2 4.1M6.6 6.6C3.9 8.4 2 12 2 12s3.6 7 10 7a9.7 9.7 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  window.CorexTextilIO = {
    esc: esc, uid: uid, round: round, fmt: fmt, normalizeDeg: normalizeDeg, parseCm: parseCm, userError: userError,
    loadPhoto: loadPhoto, packshotUrl: packshotUrl, loadOptionalPhoto: loadOptionalPhoto, thumbOf: thumbOf, alphaBox: alphaBox, densityOf: densityOf, physWidth: physWidth, readImageFile: readImageFile, readPdfFile: readPdfFile, isPdf: isPdf, importModule: importModule, swatchStyle: swatchStyle,
    ICON_EYE: ICON_EYE, ICON_EYE_OFF: ICON_EYE_OFF, ICON_TRASH: ICON_TRASH
  };
})();
